import React, { memo } from "react";
import {
  calculateDistance,
  convertToMapboxFormat,
} from "../utils/wayfinderUtils";

const WayfinderAssemblyPanel = memo(
  ({
    bibData,
    selectedRoute,
    showDirections,
    currentRouteLeg,
    routeDistance,
    userLocation,
    isLocationTrackingActive,
    locationConfirmed,
    setLocationConfirmed,
    handleDirectionsClick,
    handleStartLocationTracking,

    onLocationUpdate,
  }) => {
    return (
      <div className="assembly-info-panel">
        {isLocationTrackingActive ? null : (
          <div className="assembly-header">
            <button
              className="close-button"
              onClick={() => setLocationConfirmed(false)}
            >
              ×
            </button>
            <div className="assembly-title">
              <i className="fas fa-location-dot assembly-icon"></i>
              <h2>{bibData.assemblyPoint}</h2>
            </div>
          </div>
        )}

        <div className="assembly-details">
          {/* Current Destination Indicator */}
          {showDirections && currentRouteLeg && (
            <div className="destination-indicator">
              <i className="fas fa-flag-checkered"></i>
              <span>{`Heading to: ${bibData.assemblyPoint}`}</span>
            </div>
          )}

          <div className="distance-info">
            {showDirections && currentRouteLeg ? (
              <>
                Route Distance:{" "}
                {routeDistance ? (
                  <>
                    {routeDistance.toFixed(1)} km (~
                    {Math.round(routeDistance * 12)} min walk)
                  </>
                ) : (
                  <>Calculating... km</>
                )}
              </>
            ) : (
              <>
                Distance to Assembly:{" "}
                {(() => {
                  const currentDistance = calculateDistance(
                    userLocation[1], // lat
                    userLocation[0], // lng
                    bibData.assemblyCoordinates[0], // lat
                    bibData.assemblyCoordinates[1] // lng
                  );
                  return currentDistance.toFixed(1);
                })()}{" "}
                km (~
                {(() => {
                  const currentDistance = calculateDistance(
                    userLocation[1], // lat
                    userLocation[0], // lng
                    bibData.assemblyCoordinates[0], // lat
                    bibData.assemblyCoordinates[1] // lng
                  );
                  return Math.round(currentDistance * 12);
                })()}{" "}
                min walk)
              </>
            )}
          </div>
        </div>

        <div className="assembly-actions">
          {!isLocationTrackingActive ? (
            <button
              className={`direction-button ${showDirections ? "active" : ""}`}
              onClick={handleDirectionsClick}
              title="Show route directions"
            >
              <i
                className={`fas ${
                  showDirections ? "fa-eye-slash" : "fa-directions"
                }`}
              ></i>
              {showDirections ? "HIDE ROUTE" : "DIRECTION"}
            </button>
          ) : null}
          <button
            className={`start-button ${
              isLocationTrackingActive ? "tracking" : ""
            }`}
            onClick={() => handleStartLocationTracking(0, onLocationUpdate)}
          >
            <i
              className={`fas ${
                isLocationTrackingActive ? "fa-stop" : "fa-play"
              }`}
            ></i>
            {isLocationTrackingActive ? "STOP" : "START"}
          </button>
        </div>
      </div>
    );
  }
);

WayfinderAssemblyPanel.displayName = "WayfinderAssemblyPanel";

export default WayfinderAssemblyPanel;
